import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

const HRPlatformShowcase = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [fade, setFade] = useState(true);
    const navigate = useNavigate();
      const handleRecruit = () => navigate('/access-recruit');


  const tabs = [
    {
      name: "Core HR",
      title: "Centralize your people data",
      description:
        "Streamline employee information, documentation, and compliance in one secure platform.",
      image: "/images/divshowcase_1.png",
      features: [
        "Employee records",
        "Document management",
        "Org charts",
        "Custom workflows",
        "Mobile access"
      ]
    },
    {
      name: "Onboarding",
      title: "Run payroll without the pain",
      description:
        "Fast track payroll, ensure accuracy, and stay compliant.",
      image: "/images/divshowcase_3.png",
      features: [
        "Time tracking",
        "Benefits management",
        "Payroll integrations",
        "UK payroll",
        "US payroll"
      ]
    },
    {
      name: "Talent",
      title: "Attract and retain top talent",
      description:
        "Streamline recruiting, onboarding, and performance management seamlessly.",
      image: "/images/divshowcase_4.png",
      features: [
        "Applicant tracking",
        "Onboarding workflows",
        "Performance reviews",
        "Goal tracking",
        "Career development"
      ]
    },
    {
      name: "HR Planning",
      title: "Make data-driven decisions",
      description:
        "Visualize workforce trends, headcount, and strategic planning insights.",
      image: "/images/divshowcase_2.png",
      features: [
        "Workforce analytics",
        "Headcount planning",
        "Budget forecasting",
        "Turnover insights",
        "Diversity metrics"
      ]
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setActiveTab((prev) => (prev + 1) % tabs.length);
        setFade(true);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, [tabs.length]);

  const handleTabClick = (index) => {
    setFade(false);
    setTimeout(() => {
      setActiveTab(index);
      setFade(true);
    }, 300);
  };

  return (
    <div style={styles.wrapper}>
      {/* Top Section */}
      <div style={styles.grayContainer}>
        <div style={styles.headerSection}>
          <h1 style={styles.mainTitle}>
            All-in-one HR, from{" "}
            <span style={styles.highlight}>
               hire to retire
            </span>
          </h1>

          <p style={styles.subtitle}>
            Streamline your entire employee lifecycle with powerful tools
            designed for modern businesses.
          </p>
        </div>

        {/* Tabs */}
        <div style={styles.tabsWrapper}>
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => handleTabClick(index)}
              style={{
                ...styles.tabButton,
                background:
                  activeTab === index
                    ? "linear-gradient(135deg, #c62828, #d32f2f)"
                    : "#ffffff",
                color: activeTab === index ? "#ffffff" : "#1e2330",
                boxShadow:
                  activeTab === index
                    ? "0 8px 24px rgba(198,40,40,0.35)"
                    : "0 2px 8px rgba(0,0,0,0.06)"
              }}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Content Section */}
      <div style={styles.whiteSection}>
        <div style={styles.contentArea}>
          {/* Left */}
          <div
            style={{
              ...styles.panel,
              opacity: fade ? 1 : 0,
              transform: fade ? "translateY(0)" : "translateY(20px)"
            }}
          >
            <h2 style={styles.panelTitle}>{tabs[activeTab].title}</h2>
            <p style={styles.panelText}>{tabs[activeTab].description}</p>

            <button style={styles.primaryButton} onClick={handleRecruit}>REQUEST A DEMO</button>
            <button style={styles.secondaryButton} onClick={handleRecruit}>
              Learn more →
            </button>
          </div>

          {/* Image */}
          <div style={styles.imageWrapper}>
            <img
              src={tabs[activeTab].image}
              alt=""
              style={{
                ...styles.image,
                opacity: fade ? 1 : 0,
                transform: fade ? "scale(1)" : "scale(0.95)"
              }}
            />
          </div>

          {/* Right */}
          <div
            style={{
              ...styles.panel,
              opacity: fade ? 1 : 0,
              transform: fade ? "translateY(0)" : "translateY(20px)"
            }}
          >
            <h3 style={styles.featuresTitle}>Key Features</h3>
            <ul style={styles.featureList}>
              {tabs[activeTab].features.map((f, i) => (
                <li key={i} style={styles.featureItem}>
                  <span style={styles.tick}>✓</span> {f}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

/* ================= STYLES ================= */

const styles = {
  wrapper: {
    fontFamily: "Raleway, sans-serif",
    background: "#ffffff",
    marginTop: "-60px"
  },
  grayContainer: {
    padding: "90px 24px 60px",
    textAlign: "center"
  },
  headerSection: {
    maxWidth: "900px",
    margin: "0 auto 60px"
  },
  mainTitle: {
    fontSize: "56px",
    fontWeight: "900",
    color: "#1e2330",
    lineHeight: "1.1"
  },
  highlight: {
    color: "#c62828"
  },
  subtitle: {
    marginTop: "16px",
    fontSize: "18px",
    color: "#6b7280"
  },
  tabsWrapper: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    flexWrap: "wrap"
  },
  tabButton: {
    padding: "16px 32px",
    borderRadius: "50px",
    border: "none",
    fontWeight: "700",
    cursor: "pointer"
  },
  whiteSection: {
    padding: "80px 24px"
  },
  contentArea: {
    display: "grid",
    gridTemplateColumns: "320px 1fr 300px",
    gap: "48px",
    maxWidth: "1300px",
    margin: "0 auto"
  },
  panel: {
    background: "#fff",
    padding: "36px",
    borderRadius: "20px",
    border: "1px solid #e5e7eb",
    transition: "all 0.4s ease",
    marginTop: "-60px"
  },
  panelTitle: {
    fontSize: "30px",
    fontWeight: "800",
    marginBottom: "14px"
  },
  panelText: {
    fontSize: "16px",
    color: "#6b7280",
    marginBottom: "28px"
  },
  primaryButton: {
    width: "100%",
    padding: "16px",
    background: "#c62828",
    color: "#fff",
    border: "none",
    borderRadius: "12px",
    fontWeight: "700",
    cursor: "pointer",
    marginBottom: "12px"
  },
  secondaryButton: {
    width: "100%",
    padding: "16px",
    background: "#fff",
    color: "#c62828",
    border: "2px solid #e5e7eb",
    borderRadius: "12px",
    fontWeight: "700",
    cursor: "pointer"
  },
  imageWrapper: {
    display: "flex",
    alignItems: "center",
    marginTop: "-80px"
  },
  image: {
    width: "100%",
    borderRadius: "20px",
    transition: "all 0.4s ease",
    boxShadow: "0 20px 60px rgba(0,0,0,0.15)"
  },
  featuresTitle: {
    fontSize: "18px",
    fontWeight: "800",
    marginBottom: "20px"
  },
  featureList: {
    listStyle: "none",
    padding: 0
  },
  featureItem: {
    padding: "14px",
    background: "#f9fafb",
    borderRadius: "12px",
    marginBottom: "10px",
    display: "flex",
    gap: "10px"
  },
  tick: {
    color: "#ffffff",
    background: "#c62828",
    width: "20px",
    height: "20px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    fontSize: "12px",
    fontWeight: "800"
  }
};

export default HRPlatformShowcase;
